import type { StatusColor } from '@ztechapps/common.contract'
import { LogisticStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export type LogisticStatusDetailType = { description: string; sort: number; value: LogisticStatusEnum } & StatusColor

export type LogisticStatusType = {
  Draft: LogisticStatusDetailType
  Active: LogisticStatusDetailType
  Closed: LogisticStatusDetailType
  InActive: LogisticStatusDetailType
}

// Each custom color is a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss; it resolves only in a browser that has loaded that stylesheet.
export const LogisticStatus: LogisticStatusType = {
  Draft: {
    value: LogisticStatusEnum.Draft,
    description: 'The logistic have not started yet',
    sort: 0,
    tone: StatusToneEnum.Draft,
  },
  Active: {
    value: LogisticStatusEnum.Active,
    description: 'The logistic has started',
    sort: 1,
    color: 'var(--status-custom-olive)',
  },
  Closed: {
    value: LogisticStatusEnum.Closed,
    description: 'The logistic is done.',
    sort: 2,
    tone: StatusToneEnum.Active,
  },
  InActive: {
    value: LogisticStatusEnum.Cancelled,
    description: 'The logistic is InActive.',
    sort: 3,
    tone: StatusToneEnum.Cancelled,
  },
}
